exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".font-bold-24[data-v-4e6b3a3f]{font:normal normal 700 24px/32px Segoe UI;letter-spacing:0;color:#112639;opacity:1}.font-bold-16[data-v-4e6b3a3f]{font:normal normal 700 16px/21px Segoe UI;letter-spacing:0;color:#112639;opacity:1}.font-semibold[data-v-4e6b3a3f]{font:normal normal 600 16px/16px Segoe UI;letter-spacing:0;color:#112639;text-transform:uppercase;opacity:1}.font-regular[data-v-4e6b3a3f]{font:normal normal normal 16px/16px Segoe UI;letter-spacing:0;color:#95a1ad;opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4e6b3a3f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/requeteurModifieur/FiltreDate/FiltreDate.scss
// module id = V9nA
// module chunks = 2